const BaseURL = 'https://app-end-cursos.taller24e.org/api/';
export { 
  BaseURL,
}
